import { SpinResponseData } from "@lib/titan2-slingo/dist/api/data/SpinResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
import { SlotsGameData } from "../../data/SlotsGameData";
import { SlotsSpinData } from "../../data/SlotsSpinsData";
import { ApiConstants } from "../../enum/Constants";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { unpackChanceGameData } from "./unpackChanceGameData";
/**
 * ExtendedSpinResponseData.ts
 */
export class ExtendedSpinResponseData extends SpinResponseData {
    solidify() {
        super.solidify();
        if (this.isSuccess() && this.dataExists(this.data)) {
            this.solidifyChanceGame();
            this.solidifySlotsGame();
            this.solidifySlotsSpins();
        }
    }
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
    solidifyChanceGame() {
        this.chanceGame = null;
        const spinResult = this.data.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
        const feature = spinResult.getDataObject(ApiConstants.PROPERTY_FEATURE);
        if (feature) {
            const chanceGame = feature.getDataObject(ApiConstants.PROPERTY_CHANCE_GAME);
            this.chanceGame = unpackChanceGameData(chanceGame);
        }
    }
    solidifySlotsGame() {
        const slotsGameData = this.data.getDataObject(ApiConstants.PROPERTY_SLOTS_GAME);
        if (slotsGameData) {
            this.slotsGame = new SlotsGameData(slotsGameData);
        }
    }
    solidifySlotsSpins() {
        let slotsSpinsData = this.data.getDataArray(ApiConstants.PROPERTY_SLOTS_SPINS);
        if (slotsSpinsData && slotsSpinsData.length) {
            this.slotsSpins = slotsSpinsData.map((slotsSpin) => new SlotsSpinData(slotsSpin));
        }
    }
    getChanceGames() {
        return this.chanceGame ? [this.chanceGame] : null;
    }
    getChanceGame() {
        return this.chanceGame ?? null;
    }
    getSlotsGame() {
        return this.slotsGame || null;
    }
    getSlotsSpins() {
        return this.slotsSpins?.slice() || null;
    }
}
//# sourceMappingURL=ExtendedSpinResponseData.js.map